import React, { useState } from 'react';
import { View, Text, StyleSheet, TextInput, Image } from 'react-native';
import { VisualData } from '@eduwrite/shared';

interface Props {
    data: Extract<VisualData, { type: 'partial_fill' }>;
    context: Record<string, number | string>;
    onInput: (input: string) => void;
}

export const PartialFillVisual: React.FC<Props> = ({ data, context: _context, onInput }) => {
    const [values, setValues] = useState<Record<number, string>>({});

    const handleChange = (index: number, text: string) => {
        const updated = { ...values, [index]: text };
        setValues(updated);
        onInput(JSON.stringify(updated));
    };

    const bgWidth = 400;
    const bgHeight = 200;

    return (
        <View style={styles.container}>
            <Text style={styles.label} allowFontScaling={true} maxFontSizeMultiplier={1.5}>Fill in the blanks:</Text>
            <View style={[styles.canvas, { width: bgWidth, height: bgHeight }]}>
                {data.ghostSvgUrl && (
                    <Image
                        source={{ uri: data.ghostSvgUrl }}
                        style={StyleSheet.absoluteFill}
                        resizeMode="contain"
                        accessibilityLabel="Background diagram"
                    />
                )}
                {data.blanks.map((blank, i) => (
                    <View
                        key={i}
                        style={[
                            styles.blankOverlay,
                            {
                                left: blank.x,
                                top: blank.y,
                            },
                        ]}
                    >
                        <TextInput
                            style={styles.blankInput}
                            value={values[i] || ''}
                            placeholder="?"
                            onChangeText={(text) => handleChange(i, text)}
                            maxLength={blank.expectedText?.length || 10}
                            accessibilityLabel={`Blank ${i + 1}`}
                        />
                    </View>
                ))}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        padding: 12,
    },
    label: {
        fontSize: 16,
        fontWeight: '600',
        color: '#1E293B',
        marginBottom: 12,
    },
    canvas: {
        position: 'relative',
        backgroundColor: '#F8FAFC',
        borderRadius: 12,
        overflow: 'hidden',
    },
    blankOverlay: {
        position: 'absolute',
    },
    blankInput: {
        width: 64,
        height: 56,
        borderWidth: 2,
        borderColor: '#CBD5E1',
        borderRadius: 12,
        backgroundColor: '#FFFFFF',
        textAlign: 'center',
        fontSize: 20,
        fontWeight: '700',
        color: '#1E293B',
    },
});
